import React, { Component } from 'react'
import QuicksightDashboard from './quicksightDashboardReport';
import CLIENT_QUICKSIGHT_URL from '../../config/quicksightConfig'
import CLIENT_QUICKSIGHT_URL_UAT from '../../config/quicksightConfigUAT'
import AddTitleBar from "../../components/titleBar/add_titleBar";

export default class HistoricBatteryRunReport extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dashboardToLoad: '',
      headerTitle: '',
      linkPath: ''
    };

    this.getDashboardID = this.getDashboardID.bind(this);
  }

  componentDidMount() {
    let title = this.props.location.search;
    let pathName = this.props.location.pathname;


    title = title.replace("?", "");
    title = title.split("_").join(" ");
    title = title.charAt(0) + title.substring(1).toLowerCase();

    this.setState({ headerTitle: title, linkPath: pathName });

    if (this.props && this.props?.history?.location?.search) {
      let temp = this.props.history.location?.search.replace('?', '')
      let dashboardURL = this.getDashboardID(temp);
      console.log(dashboardURL, 'dashboardURLdashboardURL')
      this.setState({ dashboardToLoad: dashboardURL }, () => {
        console.log(this.state.dashboardToLoad)
      });
    }
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps) {
    let title = this.props.location.search;
    let pathName = this.props.location.pathname;

    title = title.replace("?", "");
    title = title.split("_").join(" ");
    title = title.charAt(0) + title.substring(1).toLowerCase();

    if (this.props != prevProps && this.props?.history?.location?.search) {
      let temp = this.props.history.location?.search.replace('?', '')
      let dashboardURL = this.getDashboardID(temp);
      this.setState({ dashboardToLoad: dashboardURL, headerTitle: title, linkPath: pathName }, () => {
        console.log(this.state.dashboardToLoad)
      });
    }
  }

  getDashboardID(id) {
    let hostName = window.location.hostname
    let hostMatch = hostName.localeCompare('fleet.elixia.tech')

    switch (id) {
      case 'HISTORIC_BATTERY_REPORT':
        if (hostMatch == 0)
          return CLIENT_QUICKSIGHT_URL.HISTORIC_BATTERY_REPORT
        else
          return CLIENT_QUICKSIGHT_URL_UAT.HISTORIC_BATTERY_REPORT
        break;
      default:
      // code block
    }
  }



  render() {
    console.log(this.props, 'this.props')
    return (
      <React.Fragment>
        <div id="dispatch_bar">
          <AddTitleBar
            Title={this.state.headerTitle}
            LinkName="/new-order"
          />
        </div>
        <div className="p-2">
          {this.state.dashboardToLoad &&
            <QuicksightDashboard dashboardToLoad={this.state.dashboardToLoad} />
          }
        </div>
      </React.Fragment>
    )
  }
}
